import React from 'react';
import { FadeLink, useCopy } from '../core';

const copy = {
  en: { code: '404', title: 'We couldn’t find that page.', text: 'Continue exploring our products, or return to the homepage.', products: 'Explore products', home: 'Go home' },
  zh: { code: '404', title: '没有找到这个页面。', text: '您可以从产品页面继续探索，或返回首页。', products: '探索产品', home: '返回首页' }
};

export default function NotFoundPage() {
  const { t } = useCopy(copy);
  return <section className="nf" aria-labelledby="nf-title">
    <div className="wrap">
      <p className="eyebrow">{t.code}</p>
      <h1 id="nf-title">{t.title}</h1>
      <p>{t.text}</p>
      <div className="ctas">
        <FadeLink className="btn btn-dark" to="/products">{t.products} <span className="ar" aria-hidden="true">↗</span></FadeLink>
        <FadeLink className="btn btn-light" to="/">{t.home}</FadeLink>
      </div>
    </div>
  </section>;
}
